import React from 'react';

import { Controller, useForm } from 'react-hook-form';

import BlurPopup from 'components/BlurPopup';
import { Checkbox, CheckboxType } from 'components/Checkbox';
import { getMessageForRequiredFields } from 'utils/validationUtils';
import { Button } from 'components/Buttons/Button';
import { ButtonType } from 'enums/ButtonType';

import styles from './LoanAgreementPopup.module.scss';

interface LoanAgreementPopupProps {
  isModalOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

const LoanAgreementPopup = ({ isModalOpen, onSubmit, onClose }: LoanAgreementPopupProps) => {
  const {
    watch,
    handleSubmit,
    control,
    formState: { errors, isSubmitted },
    setValue,
    trigger,
  } = useForm({
    defaultValues: {
      agreementCheckbox: false,
    },
  });

  const watcher = watch();

  const handleClickClose = () => {
    onClose();
  };

  const handleFormSubmit = handleSubmit(async () => {
    const result = await trigger();

    if (result) {
      onSubmit();
    }
  });

  return (
    <BlurPopup
      id="popup"
      classes={{
        paper: styles.paper,
        container: styles.container,
      }}
      onClose={handleClickClose}
      open={isModalOpen}
      scroll="body"
      blurDeep={2}
    >
      <form>
        <div className={styles.header}>**IMPORTANT LOAN MESSAGE**</div>
        <div className={styles.message}>
          By proceeding you agree that you are pursuing a residential home improvement loan for the sole purpose of
          improving your primary residence or vacation home.
        </div>
        <div className={styles.message}>
          Use of funds <span className={styles.messageBold}>NOT</span> permitted for rentals or businesses.
        </div>
        <Controller
          name="agreementCheckbox"
          control={control}
          rules={{
            required: getMessageForRequiredFields(),
            validate: (value) => {
              if (!value) {
                return getMessageForRequiredFields();
              }
            },
          }}
          render={() => (
            <div className={styles.checkboxContainer}>
              <Checkbox
                type={CheckboxType.Alternative}
                name="agreementCheckbox"
                isChecked={!!watcher.agreementCheckbox}
                onChange={() => {
                  setValue('agreementCheckbox', !watcher.agreementCheckbox);

                  if (isSubmitted) {
                    trigger();
                  }
                }}
                isValid={!errors.agreementCheckbox?.message}
                text={'Agree and proceed'}
                labelClassName={styles.checkboxTextContainer}
              />
              <p className={styles.errorMessage}>{errors.agreementCheckbox?.message}</p>
            </div>
          )}
        />
        <div className={styles.buttonsContainer}>
          <Button buttonType={ButtonType.Primary} onClick={handleFormSubmit}>
            Confirm
          </Button>
          <Button buttonType={ButtonType.Secondary} onClick={onClose}>
            Cancel
          </Button>
        </div>
      </form>
    </BlurPopup>
  );
};

export default LoanAgreementPopup;
